import React, { useState } from 'react';
import Star from 'assets/star.png';
import Star2 from 'assets/star2.png';
import './style.css';
import api from 'services/api';
import config from 'config';

const Avaliacao = (props) => {
    const [nroEstrelas, setNroEstrelas] = useState(0);
    const [denAvaliacao, setDenAvaliacao] = useState('');

    const AVALIAR = () => {
        if (nroEstrelas === 0) {
            alert('Escolha o número de estrelas!');
            return;
        }
        if (denAvaliacao.trim() === '') {
            alert('Descreva sua opinião!');
            return;
        }
        const avaliacao = { 
            id_estabelecimento: props.dados.id_estabelecimento,
            den_avaliacao: denAvaliacao,
            nro_estrelas: nroEstrelas
        };

        api.post(`${config.ESTABELECIMENTOS_AVALIACAO}`, avaliacao)
        .then(response => {
            if (response.status === 202) {
                setNroEstrelas(0);
                setDenAvaliacao('');
                props.setTrigger(false);
            } else {
                console.log(response.data.erro);
            }
        });
    };

    const CANCELAR =() => {
        setNroEstrelas(0);
        setDenAvaliacao('');
        props.setTrigger(false);
    }

    return (
        <div className='avaliacao-container'>
            <h1 >Avaliação</h1>
            <div className='avaliacao-header'>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Escolha o número de estrelas:</label>
                <div>
                        <img src={nroEstrelas > 0 ? Star : Star2} alt="Classificacao" onClick={(e)=>setNroEstrelas(1)} className="pedido-avaliar"/>
                        <img src={nroEstrelas > 1 ? Star : Star2} alt="Classificacao" onClick={(e)=>setNroEstrelas(2)}/>
                        <img src={nroEstrelas > 2 ? Star : Star2} alt="Classificacao" onClick={(e)=>setNroEstrelas(3)}/>
                        <img src={nroEstrelas > 3 ? Star : Star2} alt="Classificacao" onClick={(e)=>setNroEstrelas(4)}/>
                        <img src={nroEstrelas > 4 ? Star : Star2} alt="Classificacao" onClick={(e)=>setNroEstrelas(5)}/>
                </div>
            </div>
            <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Descreva sua opinião:</label>
                <textarea
                    value={denAvaliacao}
                    onChange={(e) => setDenAvaliacao(e.target.value)}
                    placeholder="Escreva sua avaliação aqui..."
                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minHeight: '80px' }}
                />
            </div>
            <div className='avaliacao-botoes'>
                <button
                    onClick={CANCELAR}
                    className='btn btn-danger'
                >
                    Cancelar
                </button>
                <button
                    onClick={AVALIAR}
                    className='btn btn-primary'
                >
                    Enviar Avaliação
                </button>
            </div>
        </div>
    );
};

export default Avaliacao;